<template>
  <div>
    <list
      ref="refProfileLanguageList"
      sort-by="PerfilIdiomaId"
      :refetch-records="fetchProfilesLanguage"
      refetch-records-name="perfilesIdiomas"
      :actions="actions"
      key-field="perfilIdiomaId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteProfileLanguage"
      :filters.sync="filters"
    />>
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refProfileLanguageList = ref(null)
    /* Services */
    const {
      fetchProfilesLanguage,
      deleteProfileLanguage,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.profileLanguage.columns.name'),
        key: 'perfil.nombre',
      },
      {
        label: i18n.t('humanResources.profileLanguage.columns.language'),
        key: 'idioma.nombre',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'Perfil',
        routeName: 'apps-human-resources-profile-language-edit',
        params: ['perfilIdiomaId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'Perfil',
        params: ['perfilIdiomaId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-profile-language-add',
        label: i18n.t('Routes.ProfileLanguageAdd'),
        aclAction: 'create',
        aclResource: 'Perfil',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refProfileLanguageList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchProfilesLanguage,
      deleteProfileLanguage,
    }
  },
}
</script>
